import {
    CREATE_PRJASN_START,
    CREATE_PRJASN,
    INIT, FETCH_PRJASN_START,
    LOADING, SUCCESS, ERROR,
    FETCH_PRJASN_SUCCESS,
    FETCH_PRJASN_FAILURE,
    SET_PRJASN_INIT,
    FETCH_PRJ_FAILURE,
    FETCH_PRJ_SUCCESS,
    FETCH_PRJ_START,
    UPDATE_PRJASN_START,

} from "./prjAsnTypes";

export const initialState = {
    project_id: "",
    project_name: "",
    first_name: "",
    last_name: "",
    email_id: "",
    created_by: "",
    last_updatedby: "",
    start_date: null,
    end_date: null,
    enabled_flag: "Y",
    app_name: null,
    app_description: null,
    project_number: null,
    display_name: null,
    errors: [],
    phase: INIT,
    loading: false,
    showMdl: false,
    mode: "CREATE",
    projectsAsn: [],
    projects: [],
};


const prjAsnReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_PRJASN_START:
            return {
                ...state,
                loading: true,
                phase: LOADING,
            }
        case CREATE_PRJASN:
            return {
                ...state,
                loading: true,
                userData: action.userData
            }
        case UPDATE_PRJASN_START:
            return {
                ...state,
                loading: true,
                phase: LOADING,
            }
        case FETCH_PRJASN_START:
            return {
                ...state,
                loading: true,
                phase: LOADING,
            }
        case FETCH_PRJASN_SUCCESS:
            return {
                ...state,
                projectsAsn: action.projectsAsn,
                loading: false,
                phase: SUCCESS,
            }
        case FETCH_PRJASN_FAILURE:
            return {
                ...state,
                phase: ERROR,
                loading: false,
                errors: action.errors,
            }
        case FETCH_PRJ_START:
            return {
                ...state,
                loading: true,
                phase: LOADING,
            }
        case FETCH_PRJ_SUCCESS:
            return {
                ...state,
                projects: action.projects,
                loading: false,
                phase: SUCCESS,
            }
        case FETCH_PRJ_FAILURE:
            return {
                ...state,
                phase: ERROR,
                loading: false,
                errors: action.errors,
            }
        case SET_PRJASN_INIT:
            return {
                ...state,
                phase: INIT,
                loading: false,
            }
        
        default:
            return state;
    }
}

export default prjAsnReducer;